module.exports = __webpack_public_path__ + "img/orgunits-icon-dark.f37d84a2.svg";